module.exports = __webpack_public_path__ + "img/banner-7.c0e86b0a.jpg";